<div style="padding: 15px;">
  <div class="table-title">
    <h3>Twitter Posts</h3>
  </div>
</div>


<form nz-form [formGroup]="filtersForm" class="filter-form">
  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Politician</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="politician" nzShowSearch nzAllowClear nzPlaceHolder="Zgjidh politikanin">
            <nz-option *ngFor="let politician of politicians" [nzValue]="politician.id"
              [nzLabel]="politician.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Hashtag</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="hashtag" nzShowSearch nzAllowClear nzPlaceHolder="Choose hashtag">
            <nz-option *ngFor="let hashtag of hashtags" [nzValue]="hashtag" [nzLabel]="hashtag"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Attacked</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="attackedPolitician" nzShowSearch nzAllowClear
            nzPlaceHolder="Politikani i sulmuar">
            <nz-option *ngFor="let politician of attackedPoliticians" [nzValue]="politician.id"
              [nzLabel]="politician.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

  </div>

  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Post Type</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="postType" nzShowSearch nzAllowClear nzPlaceHolder="Kategoria e postimit">
            <nz-option *ngFor="let type of types" [nzValue]="type.id" [nzLabel]="type.type"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Topic</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="topic" nzShowSearch nzAllowClear nzPlaceHolder="Tematika/ Fushata">
            <nz-option *ngFor="let topic of topics" [nzValue]="topic.id" [nzLabel]="topic.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Search text</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="searchBox" placeholder="Search by any keyword" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-form-item>
        &nbsp;&nbsp;
        <nz-form-control>
          <button nz-button nzType="primary" (click)="search()" class="search-button-container">
            <fa-icon [icon]="faSearch"></fa-icon> &nbsp;Filter
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>

<div class="table-container">
  <nz-table #basicTable [nzData]="posts" [nzFrontPagination]="false" [nzLoading]="isDataLoading" [nzTotal]="totalCount"
    [nzPageIndex]="pageNumber" [nzPageSize]="pageSize" [nzPageSizeOptions]="pageSizeOptions" [nzShowSizeChanger]="true"
    [nzShowQuickJumper]="true" (nzQueryParams)="onQueryParamsChange($event)">

    <thead>
      <tr>
        <th nzWidth="150px">Posted By</th>
        <th>Main Hashtag</th>
        <th>Post content</th>
        <th nzWidth="100px">Date</th>
        <th>Attacked politician</th>
        <th>Post type</th>
        <th>Topic / Campaign</th>
        <th nzWidth="120px">Actions</th>
      </tr>
    </thead>

    <tbody>
      @for (post of basicTable.data; track post.id) {
      <tr>
        <td>{{ post.politician?.name }}</td>
        <td>{{ post.mainHashtag }}</td>
        <td>{{ post.content }}...</td>
        <td>{{ post.date | date: 'dd.MM.yyyy' }}</td>

        <!-- Attacked Politician -->
        <td>
          @if (!editCache[post.id].edit) {
          <span style="color: #ff4d4f; font-weight: 500;">
            {{ post.attackedPolitician }}
          </span>
          } @else {
          <input #attackInput nz-input [(ngModel)]="editCache[post.id].data.attackedPolitician"
            (ngModelChange)="onAttackedPoliticianInput(attackInput.value); onAttackedPoliticianChange($event, post.id)"
            [nzAutocomplete]="autoAttack" placeholder="Type or select politician" style="width: 100%" />

          <nz-autocomplete #autoAttack>
            @for (opt of filteredAttackedPoliticians; track opt.name) {
            <nz-auto-option [nzValue]="opt.name">
              {{ opt.name }}
              @if (opt.id === 'new') {
              <small style="color: #1890ff; margin-left: 4px">(new)</small>
              }
            </nz-auto-option>
            }
          </nz-autocomplete>
          }
        </td>

        <!-- Post Type -->
        <td>
          @if (!editCache[post.id].edit) {
          {{ post.type?.type }}
          } @else {
          <nz-select [(ngModel)]="editCache[post.id].data.type!.id" (ngModelChange)="onPostTypeChange($event, post.id)"
            style="width: 100%">
            @for (type of types; track type.id) {
            @if (type.id !== 0) {
            <nz-option [nzValue]="type.id" [nzLabel]="type.type"></nz-option>
            }
            }
          </nz-select>
          }
        </td>

        <!-- Topic -->
        <td>
          @if (!editCache[post.id].edit) {
          {{ post.topic?.name }}
          } @else {
          <nz-select [(ngModel)]="editCache[post.id].data.topic!.id" style="width: 100%">
            @for (topic of topics; track topic.id) {
            @if (topic.id !== 0) {
            <nz-option [nzValue]="topic.id" [nzLabel]="topic.name"></nz-option>
            }
            }
          </nz-select>
          }
        </td>

        <!-- Actions -->
        <td>
          @if (!editCache[post.id].edit) {
          <button nz-button nzType="primary" nzShape="circle" (click)="openPostDetails(post.id)">
            <fa-icon [icon]="faView"></fa-icon>
          </button>
          <button nz-button nzType="default" nzShape="circle" (click)="startEdit(post.id)" style="margin-left: 8px">
            <fa-icon [icon]="faEdit"></fa-icon>
          </button>
          } @else {
          <button nz-button nzType="primary" nzShape="circle" (click)="saveEdit(post.id)">
            <fa-icon [icon]="faSave"></fa-icon>
          </button>
          <button nz-button nzType="default" nzShape="circle" nzDanger nz-popconfirm="Cancel changes?"
            (nzOnConfirm)="cancelEdit(post.id)" style="margin-left: 8px">
            <fa-icon [icon]="faCancel"></fa-icon>
          </button>
          }
        </td>
      </tr>
      }
    </tbody>
  </nz-table>
</div>